import { Envelope } from "../models/envelope.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getEnvelopesWithGroup = (): Promise<Envelope[]> => {
    return new Promise<Envelope[]>((resolve, reject) => {
        responseHero.get(
            `${process.env.REACT_APP_API_URL}/envelopeswithgroup`, {
            }).then((response) => {
            resolve(response.data as Envelope[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};